import React from 'react';

// Components
import Page from '../../components/Page';
import MyProfileModule from '../../components/MyProfileModule';

export default function MyProfile(props) {
  const { store, setStore } = props;
  const { t } = store;

  return (
		<Page title={t('navigation.myProfile')} flexStart justifyStart>
      <MyProfileModule store={store} setStore={setStore} />
    </Page>
  );
};
